import { render } from "./ReportingTemplates.vue?vue&type=template&id=6b8d2594&scoped=true"
import script from "./ReportingTemplates.vue?vue&type=script&lang=js"
export * from "./ReportingTemplates.vue?vue&type=script&lang=js"

import "./ReportingTemplates.vue?vue&type=style&index=0&id=6b8d2594&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8d2594"]])

export default __exports__